import React, { useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Chip,
  Avatar,
} from "@mui/material";
import FootBallImg from "../../../assets/customerAssets/football.png";
import GoalModal from "./GoalModal";

const getTime = (duration) => {
  let temp = duration;
  if (!temp) {
    return `0:00`;
  }
  if (duration > 60) {
    let min = 0;
    let sec = 0;
    min = Math.floor(temp / 60);
    sec = temp % 60;
    return `${min}:${sec}`;
  } else if (temp == 60) {
    return `1:00`;
  } else {
    return `0:${temp}`;
  }
};

const VideoComoponent = ({ img, duration, data, setLeaderboard }) => {
  const [openGoalModal, setOpenGoalModal] = useState(false);
  return (
    <>
      <Box
        className="img_div"
        sx={img ? {} : { backgroundColor: "white", opacity: 0.6 }}
        onClick={() => {
          setOpenGoalModal(true);
        }}
      >
        <img
          src={img ? img : FootBallImg}
          alt="video"
          className="img_fluid"
          style={img ? { objectFit: "cover" } : { objectFit: "contain" }}
        />
        <Box className="duration">{getTime(duration)}</Box>
      </Box>
      <GoalModal
        setOpen={setOpenGoalModal}
        open={openGoalModal}
        data={data}
        setData={setLeaderboard}
      />
    </>
  );
};

export default VideoComoponent;
